export default __webpack_public_path__ + "static/media/ico_rewards.2737dabe.png";